import { createFileRoute } from '@tanstack/react-router';

import { WorkspacesPage } from '~/features/account/workspaces-page';

export const Route = createFileRoute('/_app/account/workspaces')({
  component: WorkspacesPage,
});
